<template>
  <section class="page-content">
    <p v-if="content[page].first" class="mb-2">{{ content[page].first }}</p>
    <p v-if="content[page].second">{{ content[page].second }}</p>

    <h2 v-if="content[page].third" class="text-xl lg:text-title font-bold mb-8">{{ content[page].third }}</h2>

    <p>Non togliere tempo al tuo lavoro. Contattami subito per una consulenza gratuita.</p>


    <div  class="my-12">
      <p v-if="currentTime >= 9 && currentTime <= 19" >
        <span class="mr-4 lg:mr-12 font-bold text-caption mb-4 inline-block">chiama ora:</span>
          <span :class="'bg-' + content[page].color" id="copyPhone"  class="whitespace-no-wrap resize inline text-white text-n lg:text-lg py-2 pl-3 lg:pl-8 pr-4 lg:pr-8 mb-8 rounded-full">
            <a title="chiamami al 0532 685501" href="tel:0532685501">0532 685501</a>

          </span>
      </p>
      <p v-else>
        <span class="mr-4 lg:mr-12 font-bold text-caption">contattami via email: </span>
        <span  :class="'bg-' + content[page].color" id="copyEmail" class="resize inline text-white text-button lg:text-n  py-2 pl-3 lg:pl-12 pr-4 lg:pr-4 mb-8 rounded-full select-all">
          info@gianlucalomarco.it
          <heroicon class="hidden md:inline-block ml-4 inline" fill="#fff" @click="copyText" stroke-width="0" name="duplicate"></heroicon>
        </span>
      </p>
    </div>

  </section>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "CallToAction",
    props: {
      page: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        currentTime: moment().format('HH'),
        phone: '0532 685501',
        email: 'info@gianlucalomarco.it',
        copied: false,
        content: {
          webSite: {
            color: 'blue',
            first: null,
            second: 'Stai cercando una soluzione facile e veloce per essere presente online e farti trovare dai tuoi clienti?',
            third: 'Ecco perchè dovresti realizzazare il tuo sito web.',
          },
          webApp: {
            color: 'darth',
            first: null,
            second: 'Se anche tu hai necessità di un applicativo web in grado di svolgere funzioni specifiche che ti aiutano a gestire la tua attività allora...',
            third: 'Anche tu dovresti realizzazare la tua web app.',
          },
          mobileApp: {
            color: 'salmon',
            first: null,
            second: 'Le App mobile sono soluzioni molto potenti per offrire ai propri utenti esperienze personalizzate e sempre a portata di mano.',
            third: 'Ecco perchè realizzare la tua App mobile può darti vantaggi competitivi.',
          }
        }
      }
    },
    methods: {
      copyText() {

        let testingCodeToCopy;
        if(this.currentTime >= 9 && this.currentTime <= 19) {
          testingCodeToCopy = document.querySelector('#copyPhone')
        } else {
          testingCodeToCopy = document.querySelector('#copyEmail')
        }

        try {
          const successful = document.execCommand('copy');
          const msg = successful ? 'successful' : 'unsuccessful';

          this.copied = true;
          setTimeout(this.resetCopied,2000);
          // alert('Testing code was copied ' + msg);
        } catch (err) {
          alert('Impossibile copiare il contenuto');
        }

        /* unselect the range */
        // testingCodeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      },
      resetCopied() {
        this.copied = false;
      }
    }
  }
</script>

<style scoped>

  .resize {
    transition: width .3s ease;
  }
</style>